$( document ).ready(function() {
  $('.color-select-button').on('click', function(){
    setTimeout(function(){
    if($('.color-dropdown').hasClass('color-open')){
      $('body').removeClass('body-custom-open');
      $('.color-dropdown').removeClass('color-open');
    }
    else{
      $('body').addClass('body-custom-open');
      $('.color-dropdown').addClass('color-open');
    }
    if($('.color-select-button').hasClass('color-open')){
      $('body').removeClass('body-custom-open');
      $('.color-select-button').removeClass('color-open');
    }
    else{
      $('body').addClass('body-custom-open');
      $('.color-select-button').addClass('color-open');
    }
    },100);
  });

  $('.qity-select-button').on('click', function(){
    setTimeout(function(){
      if($('.qity-dropdown').hasClass('color-open')){
        $('body').removeClass('body-custom-open');
        $('.qity-dropdown').removeClass('color-open');
      }
      else{
        $('body').addClass('body-custom-open');
        $('.qity-dropdown').addClass('color-open');
      }
      
      if($('.qity-select-button').hasClass('open')){
        $('body').removeClass('body-custom-open');
        $('.qity-select-button').removeClass('open');
      }
      else{
        $('body').addClass('body-custom-open');
        $('.qity-select-button').addClass('open');
      }
    },100);
  });

  $('.qity-item').on('click', function(){
    $('.qity-dropdown').removeClass('color-open');
    var pid = $(this).attr('data-pid');
    var qty = $(this).attr('data-qty');
    $('.qty-label').html(qty);
    $('.qty-label').val(qty);
    $('#Quantity-product-'+pid).val(qty);
  });

   $('.qty-custom-minus').on('click', function(){
     var pid = $(this).attr('data-pid');
     var qty = $('#Quantity-product-'+pid).val();
     if(qty > 1){
       qty = eval(qty) - 1;
     }
     else{
       qty = 1;
     }
     $('.qty-label').html(qty);
     $('.qty-label').val(qty);
     $('#Quantity-product-'+pid).val(qty);
   });

  $('.qty-custom-plus').on('click', function(){
     var pid = $(this).attr('data-pid');
     var qty = $('#Quantity-product-'+pid).val();
     qty = eval(qty) + 1;
     
     $('.qty-label').html(qty);
     $('.qty-label').val(qty);
     $('#Quantity-product-'+pid).val(qty);
  });
  
    $('select.js-single-option-selector').on('change', function() {
      console.log('changed')
      let currentValue = this.value;
      $(".js-single-option-selector--custom[value='"+currentValue+"']").prop("checked",true);
    });
  $('.js-single-option-selector--custom').on('click', function() {
      let currentValue = $(this).attr('value');
     $("select.js-single-option-selector option[value='"+currentValue+"']").prop('selected', 'selected').change();

  });

  // For sticky
    $(document).on('change', 'select.select_variants', function() {
    
    let currentOPrice = $('option:selected', this).attr('variant_price');
    let currentImage = $('option:selected', this).attr('variant_image');
    
    let currentCPrice = $('option:selected', this).attr('variant_price-compare');
    $(this).closest('.custom--upsell-item-details').find('.upsell-original--price').html(currentOPrice);
    $(this).closest('.custom--upsell-item-details').find('.upsell-compare--price').html(currentCPrice);
    $(this).closest('.custom--upsell-item-details').prev('.custom--upsell-item-img').find('img').attr('src', currentImage);
    
    });

  $('.cta-pair-item').on('click', function() {
      let currentValue = $(this).attr('data-value');
    
      $('.qty-input').val(currentValue);
      $('.cta-pair-item').removeClass('active');
      $('.cta-pair-item-'+currentValue).addClass('active');
      $(this).addClass('active');
  });

  $(".apex-drawer-hit").click(function() {
    $('.apex-drawer-menu').removeClass('active');
    $('.apex-drawer-menu-dropdown').removeClass('active');
    
    var dropdownId = $(this).data("dropdown");
    if($(this).hasClass('active')){
      $(this).removeClass('active');
    }
    else{
      $(".apex-drawer-hit").removeClass('active');
      $(this).addClass('active');
      $("#" + dropdownId).addClass("active");
      $('.apex-drawer-'+dropdownId).addClass("active");
    }
  });
});

// product grid item slick slide setup
$('.product-slick').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

setInterval(function () {
  $('.product-slick').each(function(i, obj) {
    if($(this).hasClass('slick-slider')){
      
    }
    else{
      $(this).slick({
        dots: true,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });
}, 1000);


	
$('.sizeguide-tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');
    $('.sizeguide-tabs .sgtab-link').removeClass('current');
    $('.sgtab-content').removeClass('current');

    $(this).addClass('current');
    $("."+tab_id).addClass('current');
});

// LOGO MARQUEE
$('.logo_marquee_slider').slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  cssEase: 'linear',
  arrows: false,
  dots: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 6,
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 4,
      }
    },
  ]
});
// END :: LOGO MARQUEE

// START :: ANNOUNCEMENT SLIDER 

$('.announcement_slider').slick({
  draggable: true,
  arrows: false,
  autoplay: true,
  dots: true,
  fade: true,
  speed: 900,
  infinite: true,
  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
  touchThreshold: 100
})

// END :: ANNOUNCEMENT SLIDER

// START :: Development — GTE_057_Product 
$(document).ready(function() {
  const $popupModal = $('#video-popup');
  const $popupVideo = $('#popup-video');
  const $closeBtn = $('.pvideo-close');
  const $pvideoBoxes = $('.pvideo-box');
  //const $pvideoBoxes2 = $('.pvideo-box2');
  const $body = $('body');

  // When a pvideo-box is clicked
  $('.pvideo-box').on('click',function(e) {
    var videoSrc = $(this).attr('data-video');
    console.log("5")
    $('#video-popup').css('display', 'flex');  
    $('body').addClass('pvideo-modal-open'); 
    $('#popup-video').find('source').attr('src', videoSrc);
    $popupVideo[0].load();
    e.stopPropagation();
  });
  
  // $(document).on('click', $pvideoBoxes2, function() {
  //   const videoSrc2 = $(this).attr('data-video');
  //   console.log("videoSrc-->", $(this))
  //   $popupVideo.find('source').attr('src', videoSrc2);
  //   $popupVideo[0].load();
  //   $popupModal.css('display', 'flex');  
  //   $body.addClass('pvideo-modal-open'); 
  // });

  // Close popup when clicking on the close button
  $('.pvideo-close').on('click',function(e) {
  //$(document).on('click', $closeBtn, function() {
    $popupModal.hide();
    $popupVideo[0].pause(); 
    $body.removeClass('pvideo-modal-open');
  });

  // Optionally close popup when clicking outside the video area
  // $(window).on('click', function(event) {
  //   if ($(event.target).is($popupModal)) {
  //     $popupModal.hide();
  //     $popupVideo[0].pause(); 
  //     $body.removeClass('pvideo-modal-open');
  //   }
  // });
});
// END :: Development — GTE_057_Product 

/* START -- PRODUCT RECOMMENDATION */

$(document).ready(function(){
  $('ul.pr_tabs_titles li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.pr_tabs_titles li').removeClass('current');
    $('.pr_tab_content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  });
})

/* END -- PRODUCT RECOMMENDATION */

//:::::::::::::::::::::::: CART-DARWER-UPSELLS-V-1 START
var intervalSlide = setInterval(function () {
  if($('body').hasClass('custom--upsell-inner-one')){
    if ($('body.custom--upsell-inner-one').find('.custom--section--upsells').find(".custom__upsells").hasClass("slick-initialized") == false) {
      $('body').find('.custom--section--upsells').find('.custom__upsells').removeClass('custom--upsell-inner');
      $('body').find('.custom--section--upsells').find(".custom__upsells").slick({
        slidesToShow: 1.3,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        slide:'.custom--upsell-item'
      });
      var getIndex = $(
        "body.custom--upsell-inner-one .custom--section--upsells .custom__upsells .slick-slide.slick-current.slick-active"
      ).attr("tabindex");
      if (
        getIndex == 0 &&
        $("body.custom--upsell-inner-one .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").hasClass(
          "disabled"
        ) == false
      ) {
        $("body.custom--upsell-inner-one .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").addClass(
          "disabled"
        );
      }
      $("body.custom--upsell-inner-one .custom--section--upsells .custom__upsells").on(
        "afterChange",
        function (event, slick, currentSlide) {
          if (currentSlide != 0) {
            $("body.custom--upsell-inner-one .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").removeClass(
              "disabled"
            );
          } else {
            $("body.custom--upsell-inner-one .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").addClass(
              "disabled"
            );
          }
        }
      );
    } 
    else {
      clearInterval(intervalSlide);
    }
  }
}, 1000);

//:::::::::::::::::::::::: CART-DARWER-UPSELLS-V-2 START
var intervalSlide = setInterval(function () {
  if($('body').hasClass('custom--upsell-inner-two')){
    if ($('body.custom--upsell-inner-two').find('.custom--section--upsells').find(".custom__upsells").hasClass("slick-initialized") == false) {
      $('body.custom--upsell-inner-two').find('.custom--section--upsells').find('.custom__upsells').removeClass('custom--upsell-inner');
      $('body.custom--upsell-inner-two').find('.custom--section--upsells').find(".custom__upsells").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        slide:'.custom--upsell-item'
      });
      var getIndex = $(
        "body.custom--upsell-inner-two .custom--section--upsells .custom__upsells .slick-slide.slick-current.slick-active"
      ).attr("tabindex");
      if (
        getIndex == 0 &&
        $("body.custom--upsell-inner-two .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").hasClass(
          "disabled"
        ) == false
      ) {
        $("body.custom--upsell-inner-two .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").addClass(
          "disabled"
        );
      }
      $("body.custom--upsell-inner-two .custom--section--upsells .custom__upsells").on(
        "afterChange",
        function (event, slick, currentSlide) {
          if (currentSlide != 0) {
            $("body.custom--upsell-inner-two .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").removeClass(
              "disabled"
            );
          } else {
            $("body.custom--upsell-inner-two .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").addClass(
              "disabled"
            );
          }
        }
      );
    } 
    else {
      clearInterval(intervalSlide);
    }
  }
}, 1000);

//:::::::::::::::::::::::: CART-DARWER-UPSELLS-V-4 START
var intervalSlide = setInterval(function () {
  if($('body').hasClass('custom--upsell-inner-four')){
    if ($('body.custom--upsell-inner-four').find('.custom--section--upsells').find(".custom__upsells").hasClass("slick-initialized") == false) {
      $('body.custom--upsell-inner-four').find('.custom--section--upsells').find('.custom__upsells').removeClass('custom--upsell-inner');
      $('body.custom--upsell-inner-four').find('.custom--section--upsells').find(".custom__upsells").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        infinite: false,
        slide:'.custom--upsell-item'
      });
      var getIndex = $(
        "body.custom--upsell-inner-four .custom--section--upsells .custom__upsells .slick-slide.slick-current.slick-active"
      ).attr("tabindex");
      if (
        getIndex == 0 &&
        $("body.custom--upsell-inner-four .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").hasClass(
          "disabled"
        ) == false
      ) {
        $("body.custom--upsell-inner-four .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").addClass(
          "disabled"
        );
      }
      $("body.custom--upsell-inner-four .custom--section--upsells .custom__upsells").on(
        "afterChange",
        function (event, slick, currentSlide) {
          if (currentSlide != 0) {
            $("body.custom--upsell-inner-four .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").removeClass(
              "disabled"
            );
          } else {
            $("body.custom--upsell-inner-four .custom--section--upsells .custom__upsells .slick-prev.slick-arrow").addClass(
              "disabled"
            );
          }
        }
      );
    } else {
      //clearInterval(intervalSlide);
    }
  }
}, 1000);
//:::::::::::::: CART-DARWER-UPSELLS-V-4 END

// :::::::::::::::::: Collection fitler [Development — GTE_066_Collection] ::::: START :::::

document.addEventListener("DOMContentLoaded", () => {
  const layoutButtons = document.querySelectorAll(".collection-layout-button");
  const productGrid = document.querySelector(".collection-list-products");

  const changeLayout = (button, gridClass) => {
    productGrid.classList.remove("two-grids", "single-grids", "three-grids");
    productGrid.classList.add(gridClass);

    layoutButtons.forEach((btn) => btn.classList.remove("collection-layout-button--active"));
    button.classList.add("collection-layout-button--active");
  };

  layoutButtons.forEach((button) => {
    button.addEventListener("click", () => {
      if (button.classList.contains("collection-layout-button--twogrid")) {
        changeLayout(button, "two-grids");
      } else if (button.classList.contains("collection-layout-button--single")) {
        changeLayout(button, "single-grids");
      } else if (button.classList.contains("collection-layout-button--three")) {
        changeLayout(button, "three-grids");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  // Append content for Length and Color filters after their respective buttons
  const lengthButton = document.querySelector(".js-filter-length");
  const colorButton = document.querySelector(".js-filter-color");
  const drawer = document.querySelector("#dbtfyCollectionFilter");

  const originalLengthContent = document.querySelector(".drawer--inner-length");
  const originalColorContent = document.querySelector(".drawer--inner-colour");

  if (!lengthButton || !colorButton || !originalLengthContent || !originalColorContent) {
    console.warn("One or more required elements are missing. Script stopped.");
    return;
  }

  const lengthContent = document.querySelector(".drawer--inner-length").cloneNode(true);
  const colorContent = document.querySelector(".drawer--inner-colour").cloneNode(true);
  
  lengthContent.style.display = "none";
  colorContent.style.display = "none";

  lengthButton.parentElement.appendChild(lengthContent);
  colorButton.parentElement.appendChild(colorContent);

  // Event listener for buttons
  document.querySelectorAll(".collection-filters-btn").forEach((button) => {
    button.addEventListener("click", function () {
      const filterType = this.classList.contains("js-filter-length")
        ? "drawer--inner-length"
        : "drawer--inner-colour";

      // Get the corresponding content
      const content = this.parentElement.querySelector(`.${filterType}`);

      // Check if content is already visible
      const isVisible = content.style.display === "block";

      // Hide all contents
      document.querySelectorAll(".drawer--inner-length, .drawer--inner-colour").forEach((content) => {
        content.style.display = "none";
      });

      // Show the clicked filter's content if it's not already visible
      if (!isVisible) {
        content.style.display = "block";
        this.style.display = "none"; // Hide the corresponding button
      } else {
        content.style.display = "none";
        this.style.display = "inline-block"; // Show the button back
      }
    });
  });

  // Event listener to hide content and show the button when inner value is clicked
  document.querySelectorAll(".drawer--inner-length, .drawer--inner-colour").forEach((content) => {
    content.addEventListener("click", (event) => {
      if (event.target.tagName === "INPUT" || event.target.tagName === "LABEL") {
        content.style.display = "none";

        // Show the corresponding button
        if (content.classList.contains("drawer--inner-length")) {
          lengthButton.style.display = "inline-block";
        } else if (content.classList.contains("drawer--inner-colour")) {
          colorButton.style.display = "inline-block";
        }
      }
    });
  });

  // Ensure the original sections in the drawer are visible
  const ensureDrawerVisibility = () => {
    document.querySelectorAll("#dbtfyCollectionFilter .drawer--inner-length, #dbtfyCollectionFilter .drawer--inner-colour").forEach((element) => {
      element.style.display = "block";
    });
  };

  // Run this logic whenever the drawer is toggled
  document.querySelector(".js-drawer-open-button-left").addEventListener("click", ensureDrawerVisibility);
});

// :::::::::::::::::: Collection fitler [Development — GTE_066_Collection] ::::: END :::::


// :::::::::::::::::: Product Quantity [Development — GTE_064_Product] ::::: START :::::
$(document).ready(function () {
  $(".quantity-box").on("click", function () {
    // Remove 'is-active' class from all .qv-box elements
    $(".quantity-box").removeClass("is-active");
    
    // Add 'is-active' class to the clicked element
    $(this).addClass("is-active");
    
    // Get data-limit value and update the quantity input
    let quantityLimit = $(this).data("limit");
    $(".qty-input").val(quantityLimit);
  });
});

$(document).ready(function () {
  var $qtyInput = $(".qty-input");
  var $progressCols = $(".bundle_progress_col");
  var $progressLine = $(".bundle_progress_linefill");
  var $messageBlank = $(".bundle_message_blank");
  var $messageFill = $(".bundle_message_fill");
  var $messageSpan = $(".bundle_message_blank span");
  var $minusBtn = $(".js-qty__adjust--minus");
  var $plusBtn = $(".js-qty__adjust--plus");

  function updateProgress() {
    var qty = parseInt($qtyInput.val(), 10) || 1;
    if (qty > 4) qty = 4;
    
    // Update progress bar
    $progressCols.not(":first").removeClass("active");
    $progressCols.slice(1, qty).addClass("active");
    var width = (qty - 1) * 33.3;
    $progressLine.css("width", width + "%");

    // Update message
    var remaining = 3;
    if(qty!=1){
      remaining = Math.max(4 - qty, 0);
    }
    if (remaining > 0) {
      $messageSpan.text(remaining + " more");
      $messageBlank.show();
      $messageFill.hide();
    } else {
      $messageBlank.hide();
      $messageFill.show();
    }
  }

  // Event listeners
  $qtyInput.on("input change keyup", updateProgress);
  $plusBtn.on("click", function () { setTimeout(updateProgress, 50); });
  $minusBtn.on("click", function () { setTimeout(updateProgress, 50); });

  // Initial setup
  $progressCols.first().addClass("active");
  updateProgress();
});

// :::::::::::::::::: Product Quantity [Development — GTE_064_Product] ::::: END :::::

// Custom JS

document.addEventListener("DOMContentLoaded", function () {
    const tocContainer = document.getElementById("table-of-contents");
    const headings = document.querySelectorAll(".toc-heading");

    if (!tocContainer || headings.length === 0) return;

    headings.forEach((heading, index) => {
        if (!heading.id) {
            heading.id = "toc-heading-" + index;
        }

        const listItem = document.createElement("li");
        const link = document.createElement("a");
        link.href = "#" + heading.id;
        link.innerText = heading.innerText;
        link.style.textDecoration = "none";

        link.addEventListener("click", function (e) {
            e.preventDefault();

            // Remove the class from all parent divs
            document.querySelectorAll(".highlight-parent").forEach(parent => {
                parent.classList.remove("highlight-parent");
            });

            // Get the parent div of the heading
            const parentDiv = heading.closest("div");

            if (parentDiv) {
                parentDiv.classList.add("highlight-parent");
            }

            // Scroll to the heading smoothly
            heading.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });

        listItem.appendChild(link);
        tocContainer.appendChild(listItem);
    });
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".read-more-container").forEach(container => {
        const readMoreBtn = container.querySelector(".read-more-btn");
        const moreText = container.querySelector(".more-text");
        const readMoreText = container.querySelector(".read-more-text");

        if (readMoreBtn && moreText) {
            readMoreBtn.addEventListener("click", function () {
                if (moreText.style.display === "none" || moreText.style.display === "") {
                    moreText.style.display = "inline"; // Show the hidden text
                    readMoreText.style.webkitLineClamp = "unset"; // Remove line limit
                    readMoreBtn.innerText = readMoreBtn.innerText.replace("Read More", "Read Less"); // Change button text
                } else {
                    moreText.style.display = "none"; // Hide again
                    readMoreText.style.webkitLineClamp = "2"; // Set line limit back
                    readMoreBtn.innerText = readMoreBtn.innerText.replace("Read Less", "Read More"); // Change button text back
                }
            });
        }
    });
});

if (window.matchMedia("(max-width: 767px)").matches) {
    $('.logo-wrap').slick({
    infinite: true,
    slidesToShow: 2.2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
       {
        breakpoint: 475,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: '0px'
        }
      },
      {
        breakpoint: 389,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '30px'
        }
      }
    ]
  });
} 

$('.testimonial-wrap').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  autoplay: true,
  autoplaySpeed: 5000,
    responsive: [
     {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    },
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        centerMode: false,
        arrows: true,
        dots: true,
      },
    },
  ],
});

// PRODUCT COLOR WRAPPER -- START
$(".pcs-color-view.pcs-color-view-nine .pcs-view-all").on("click", function () {
  $('.pcs-view-less').show();
  $(this).hide();
  $('.pcs-color-item.hide_swatch_li_nine').addClass('show_swatch_li');
  $('.pcs-color-view').addClass('pcs-color-view-active');
});
$(".pcs-color-view.pcs-color-view-nine .pcs-view-less").on("click", function () {
  $('.pcs-view-all').show();
  $(this).hide();
  $('.pcs-color-item.hide_swatch_li_nine').removeClass('show_swatch_li');
  $('.pcs-color-view').removeClass('pcs-color-view-active');
});

$(".pcs-color-view.pcs-color-view-eleven .pcs-view-all").on("click", function () {
  $('.pcs-view-less').show();
  $(this).hide();
  $('.pcs-color-item.hide_swatch_li_eleven').addClass('show_swatch_li');
  $('.pcs-color-view').addClass('pcs-color-view-active');
});
$(".pcs-color-view.pcs-color-view-eleven .pcs-view-less").on("click", function () {
  $('.pcs-view-all').show();
  $(this).hide();
  $('.pcs-color-item.hide_swatch_li_eleven').removeClass('show_swatch_li');
  $('.pcs-color-view').removeClass('pcs-color-view-active');
});

if(jQuery('.product-single__meta').find('.pcs-colors .pcs-color-item').length>0){
  jQuery('.product-single__meta .pcs-colors li.pcs-color-item').each(function () {
      var $li = jQuery(this);
      var $anchor = $li.find('a');
      //console.log("anchorHref",anchorHref,cleanUrl);
      if ($anchor.hasClass('is-active')) {
        $li.prependTo('.pcs-color-grid');
        return false;
      }
   });
}
// PRODUCT COLOR WRAPPER -- END

// product_below_benefit Read more START

$(document).on('click','.product_below_benefit.product_benefit_v2 p a',function() {
  if ($('.product_below_benefit.product_benefit_v2 p a').text() == "Read more") {
    $('.product_below_benefit.product_benefit_v2').addClass('read_more');
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
    $('.product_below_benefit.product_benefit_v2').removeClass('read_more');
  }
});

// product_below_benefit Read more END

// Product Trust Badges Start

$(".ptb-item-wrapper").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    arrows: false,
    dots: false,
    cssEase: "linear",
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1240,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
});

// Product Trust Badges End

// FAQ HOME -- START
$(document).ready(function () {
  $(".home-set > a").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".home-content").slideUp(200);
      $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
    } else {
      $(".home-set > a").removeClass("active");
      $(".home-content").slideUp(200);
      $(".home-set > a i").removeClass("fa-minus").addClass("fa-plus");

      $(this).addClass("active");
      $(this).siblings(".home-content").slideDown(200);
      $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
    }
  });

  // faq page
  $(".new-set > a").on("click", function (e) {
      e.preventDefault();

      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".new-content").slideUp(200);
        $(this).find("i").removeClass("fa-minus").addClass("fa-plus");
      } else {
        $(".new-set > a").removeClass("active");
        $(".new-content").slideUp(200);
        $(".new-set > a i").removeClass("fa-minus").addClass("fa-plus");

        $(this).addClass("active");
        $(this).siblings(".new-content").slideDown(200);
        $(this).find("i").removeClass("fa-plus").addClass("fa-minus");
      }
    });
  
});
// FAQ HOME -- END

// SOCIAL MEDIA SCROLL -- START
$(".social-media-scrollbar").slick({
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  arrow:false,
  dots:false,
  speed: 8000,
  pauseOnHover: false,
  infinite: true,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});
// SOCIAL MEDIA SCROLL -- END


$(document).ready(function () {
  //const productId = 46656748224735; // Protection old product ID comment on (06/11/2025)
  const productId = 46076881895582;
  // Function: go to checkout
  function goToCheckout() {
    window.location.href = "/checkout";
  }

  // Function: add product if not already in cart
  function addProductAndCheckout() {
    $.getJSON('/cart.js', function(cart) {
      const exists = cart.items.some(item => item.id === productId);
      if (exists) {
        goToCheckout();
      } else {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({
            id: productId,
            quantity: 1,
            properties: {
              "_type": "shipping_product"
            }
          }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            goToCheckout();
          },
          error: function (xhr, status, error) {
            console.error("Error adding product:", xhr.responseText);
            goToCheckout();
          }
        });
      }
    });
  }

  // Function: remove product if exists
  function removeProductAndCheckout() {
    $.getJSON('/cart.js', function(cart) {
      const item = cart.items.find(i => i.id === productId);
      console.log("item--->", item)
      if (item) {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({ id: item.key, quantity: 0 }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            goToCheckout();
          }
        });
      } else {
        goToCheckout();
      }
    });
  }

  // Checkout button click
  // $(document).on("click", ".btn--checkout", function(e){
  //   console.log("innnnn");

  //   if (theme.cart.item_count == 1) {
  //     console.log("cart", theme.cart.items[0].title);

  //     if (theme.cart.items[0].title == '24H PRIORITY PROCESSING') {
  //       alert("You can't checkout with this product");
  //       $(this).removeClass('btn--loading').removeAttr('disabled');
  //       e.preventDefault();
  //     } else {
  //       e.preventDefault();
  //       addProductAndCheckout();
  //     }
  //   } else {
  //     e.preventDefault();
  //     addProductAndCheckout();
  //   }
  // });

  $(document).on("click", ".btn--checkout", function(e){
    if (theme.cart.item_count >= 1) {
      e.preventDefault();
      goToCheckout();
    }
  });

  // "Checkout without package protection" link
  $(document).on("click", "a.without_protection", function(e) {
    e.preventDefault();
    removeProductAndCheckout();
  });
});

// CUSTOM BUNDLE MODCALF -- START
jQuery(document).on('click', '.custom_bundle_item', function () {
  // Remove active from all items
  jQuery('.custom_bundle_item').removeClass('active');

  // Add active to clicked item
  jQuery(this).addClass('active');
});

jQuery(document).on('change', '.cp_color_select', function(){
  var selVal = $(this).val();
  if($('.custom_bundle_block').find('.custom_bundle_item.active').length){
    var budnelActive = $('.custom_bundle_block').find('.custom_bundle_item.active');
    $(this).parent('.cb_listing_item').find('.cp_size_select').removeClass('active');
    $(this).parent('.cb_listing_item').find('.cp_size_select').hide();
    $(this).parent('.cb_listing_item').find('.bun_pro_'+selVal).addClass('active');
    $(this).parent('.cb_listing_item').find('.bun_pro_'+selVal).show();
  }
});
// CUSTOM BUNDLE MODCALF -- END